"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputView = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _theming = require("@storybook/theming");

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var smallInput = function smallInput() {
  return "\n  width: calc(100% / 3 - 6px);\n";
};

var mediumInput = function mediumInput() {
  return "\n  width: calc(100% / 2 - 12px);\n";
};

var largeInput = function largeInput() {
  return "\n  width: 100%;\n";
};

var inputSize = {
  small: smallInput(),
  medium: mediumInput(),
  large: largeInput()
};

var nakedWrapper = function nakedWrapper() {
  return "\n  padding: 0;\n  margin-bottom: 0;\n  background: \"transparent\"\n";
};

var defaultWrapper = function defaultWrapper(background, color) {
  return "\n  background-color: ".concat(background ? background : "rgba(0, 0, 0, 0.04)", ";\n  padding: 8px 15px 0px;\n  margin-bottom: 10px;\n  border-bottom: 1px solid ").concat(color, ";\n  border-radius: 4px 4px 0 0;\n  box-sizing: border-box;\n");
};

var InputView = _styled.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  ", "\n\n  .input-group {\n    display: flex;\n  }\n\n  .input {\n    display: bock;\n    width: 100%;\n  }\n\n  .input-label {\n    font-size: 12px;\n    color: ", ";\n    letter-spacing: 0.4px;\n  }\n\n  .error {\n    color: red;\n    margin-bottom: 5px;\n  }\n\n  .icon---start {\n    margin-left: 5px;\n    margin-right: 5px;\n    order: 1;\n  }\n\n  .icon--end {\n    margin-left: 5px;\n    margin-right: 5px;\n    order: 2;\n  }\n"])), function (_ref) {
  var variant = _ref.variant,
      background = _ref.background,
      color = _ref.color;
  return variant === "naked" ? nakedWrapper() : defaultWrapper(background, color);
}, function (_ref2) {
  var size = _ref2.size;
  return inputSize[size];
}, function (_ref3) {
  var color = _ref3.color;
  return color;
});

exports.InputView = InputView;

//# sourceMappingURL=Input.styles.js.map